<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <NfeCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>


import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import NfeCreateUpdate from '../../../components/modules/tax-document/nfe/NfeCreateUpdate.vue'

export default {
  name: "NfeCreateUpdateView",
  components: {
    ViewTemplateWithSalveCancel,
    NfeCreateUpdate, NfeCreateUpdate
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Nota Fiscal",
        title: "Nfe (Remessa)",
        formName: "nfseCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
};
</script>
